export const SET_LANG = "@@i18n/SET_LANG"
